import { Component, Input } from '@angular/core';
import {
  ShiftTimeAndFlexResponse,
  BaseInquiryShiftsWithFlex,
  ShiftTimeResponse,
  SimilarInquiryMappedInterface,
  BaseShiftIcons,
  BaseShiftsWithFlexArray,
} from 'base';

@Component({
  selector: 'base-customer-shift-plan-similar-inquiries',
  templateUrl: './base-customer-shift-plan-similar-inquiries.component.html',
})
export class BaseCustomerShiftPlanSimilarInquiriesComponent {
  /** Loaded and mapped by base-customer-shift-plan, which feeds the md panel from the same list. */
  @Input() similarInquiries: SimilarInquiryMappedInterface[] = [];

  shiftTimes: (ShiftTimeResponse & { index: number; label?: string })[] = [];
  shiftTimesWithFlex: (ShiftTimeAndFlexResponse & { index: number; label?: string })[] = BaseShiftsWithFlexArray.map(
    (type) => ({
      endTime: '',
      startTime: '',
      break: 0,
      type: type,
      label: type,
      index: 0,
    })
  );

  baseShiftIconsEnum = BaseShiftIcons;
  inquiryShiftTypes = BaseInquiryShiftsWithFlex;

  trackByInquiry(_: number, item: SimilarInquiryMappedInterface) {
    return item.data.id;
  }
}
